import type { GUID } from "@pdfking/tfunc"
import { UInt8Hash } from "@pdfking/tfunc"

import type { ImageArray } from "../../types/ImageArray"

export const ImageHash = (image: ImageArray): Promise<GUID> =>
  UInt8Hash([image.data])
